/* eslint-disable @typescript-eslint/no-explicit-any*/
import {
  EMPLOYEES_LIST,
  EMPLOYEES_PAYMENT_STATUS,
  EMPLOYEES_UPLOAD_LOG,
  EMPLOYEES_PAYMENT_LIST,
  CLEAN_PAYMENT_STATUS,
  PAYMENT_APPROVAL_SUCCESS,
  CLEAN_APPROVAL_STATUS,
  EMPLOYEE_TRANSACTION_LIST,
  EMPLOYEE_ACCOUNT_DETAIL,
  PAYMENT_TYPES,
  EASY_CREDIT_LIST,
} from '../actions/actionTypes';

export const initialState: reducers.EmployeesReducer = {
  list: [],
  count: 0,
  uploadLog: [],
  logCount: 0,
  paymentStatus: 0,
  paymentList: [],
  paymentCount: 0,
  paymentApprovalSuccess: 0,
  employeeTransactionList: [],
  employeeAccountDetail: null,
  paymentTypes: [],
  easyCreditList: [],
  easyCreditCount: 0,
};

const employeesReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case EMPLOYEES_LIST:
      return {
        ...state,
        list: action.payload.rows,
        count: action.payload.count,
      };
    case EMPLOYEES_UPLOAD_LOG:
      return {
        ...state,
        uploadLog: action.payload.rows,
        logCount: action.payload.count,
      };

    case EMPLOYEES_PAYMENT_STATUS:
      return {
        ...state,
        paymentStatus: action.payload,
      };

    case EMPLOYEES_PAYMENT_LIST:
      return {
        ...state,
        paymentList: action.payload.rows,
        paymentCount: action.payload.count,
      };

    case CLEAN_PAYMENT_STATUS:
      return {
        ...state,
        paymentStatus: 0,
      };

    case PAYMENT_APPROVAL_SUCCESS:
      return {
        ...state,
        paymentApprovalSuccess: action.payload,
      };

    case CLEAN_APPROVAL_STATUS:
      return {
        ...state,
        paymentApprovalSuccess: 0,
      };

    case EMPLOYEE_TRANSACTION_LIST:
      return {
        ...state,
        employeeTransactionList: action.payload.rows,
      };

    case EMPLOYEE_ACCOUNT_DETAIL:
      return {
        ...state,
        employeeAccountDetail: action.payload,
      };

    case PAYMENT_TYPES:
      return {
        ...state,
        paymentTypes: action.payload,
      };

    case EASY_CREDIT_LIST:
      return {
        ...state,
        easyCreditList: action.payload.rows,
        easyCreditCount: action.payload.count,
      };

    default:
      return state;
  }
};

export default employeesReducer;
